<template>
  <div class="edit_tarrifs">
    <v-data-table
      :headers="headers"
      :items="Tariffs"
      :items-per-page="5"
      class="elevation-1"
    >
      <template v-slot:item.comercial_calc="{ item }">
        {{ item.comercial_calc }}
      </template>
      <template v-slot:item.dop_situation_filter="{ item }">
        {{ item.dop_situation_filter }}
      </template>
      <template v-slot:item.dop_customer_filter="{ item }">
        {{ item.dop_customer_filter }}
      </template>
      <template v-slot:item.calc_filter="{ item }">
        {{ item.calc_filter }}
      </template>
      <template v-slot:item.history_request="{ item }">
        {{ item.history_request == 1 ? "Да" : "Нет" }}
      </template>
      <template v-slot:item.add_users="{ item }">
        {{ item.add_users == 1 ? "Да" : "Нет" }}
      </template>
      <template v-slot:item.api="{ item }">
        {{ item.api == 1 ? "Да" : "Нет" }}
      </template>
      <template v-slot:item.download_report="{ item }">
        {{ item.download_report == 1 ? "Да" : "Нет" }}
      </template>
      <template v-slot:item.users_report="{ item }">
        {{ item.users_report == 1 ? "Да" : "Нет" }}
      </template>
      <template v-slot:item.personal_manager="{ item }">
        {{ item.personal_manager == 1 ? "Да" : "Нет" }}
      </template>
      <template v-slot:item.add_improvement="{ item }">
        {{ item.add_improvement == 1 ? "Да" : "Нет" }}
      </template>
      <template v-slot:item.telegram_chat="{ item }">
        {{ item.telegram_chat == 1 ? "Да" : "Нет" }}
      </template>
      <template v-slot:item.valid_period="{ item }">
        {{ `${item.valid_period} дней` }}
      </template>
      <template v-slot:item.time_support="{ item }">
        {{
          item.time_support == 0 ? ` Нет тех поддержки` : `${item.time_support}`
        }}
      </template>
      <template v-slot:item.payment_type="{ item }">
        {{ Array.from(item.payment_type).join(", ") }}
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn small icon @click="editItem(item)">
          <v-icon small>edit</v-icon>
        </v-btn>
        <v-btn small icon @click="deleteItem(item)">
          <v-icon small>delete_forever</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  name: "edit_tarrifs",
  components: {},
  data: () => ({
    headers: [
      { text: "#", value: "id" },
      { text: "Название тарифа", value: "title" },
      { text: "История расчетов", value: "history_request" },
      { text: "Расчеты по коммерции", value: "comercial_calc" },
      {
        text: "Дополнительные фильтры по ситуации",
        value: "dop_situation_filter",
      },
      {
        text: "Дополнительные фильтры по заказчикам",
        value: "dop_customer_filter",
      },
      { text: "Фильтры в результатах расчета", value: "calc_filter" },
      { text: "Добавиление пользователей", value: "add_users" },
      { text: "Скачивание расчетов", value: "download_report" },
      { text: "Уведомления о победах", value: "users_report" },
      { text: "Персональный менеджер", value: "personal_manager" },
      { text: "Время поддержки", value: "time_support" },
      // { text: "Учет пожеланий к доработке сервиса", value: "add_improvement" },
      { text: "Телеграм чат", value: "telegram_chat" },
      { text: "API для размещения на своём ресурсе", value: "api" },
      { text: "Период", value: "valid_period" },
      { text: "Количество запросов", value: "count_request" },
      { text: "Цена", value: "price" },
      { text: "Методы оплаты", value: "payment_type" },
      { text: "Действия", value: "action" },
    ],
  }),
  methods: {
    getTarrifs() {
      this.$store.dispatch("GET_PAYMENTS_TARIFFS");
    },
    editItem(item) {
      this.$store.commit("setTariff", item);
      this.$store.commit("setAdded", false);
    },
    deleteItem(item) {
      this.$store.dispatch("DELETE_PAYMENTS_TARIFFS", item);
    },
  },
  computed: {
    Tariffs() {
      return this.$store.getters.tariffs;
    },
  },
  created() {
    this.getTarrifs();
  },
};
</script>
<style lang="sass" scoped></style>
